exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width: 1024px){.mobile-only[data-v-3168bdab]{display:none !important}}@media (max-width: 1023px){.desktop-only[data-v-3168bdab]{display:none !important}}.label[data-v-3168bdab]{display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between}[data-v-3168bdab] .a-product-quantity{margin-top:1rem;height:3rem;min-height:3rem}.sf-divider[data-v-3168bdab]{margin-top:var(--spacer-xl)}\n", ""]);

// exports
